import React, { useEffect, useState } from 'react';
import { Alert } from '../ui';

export default function Toast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const id = Date.now() + Math.random();
      const t = { id, message: e.detail.message, type: e.detail.type || 'info' };
      setToasts((s) => [...s, t]);
      // auto-remove
      setTimeout(() => {
        setToasts((s) => s.filter((x) => x.id !== id));
      }, e.detail.duration || 4000);
    };
    window.addEventListener('footy-notify', handler);
    return () => window.removeEventListener('footy-notify', handler);
  }, []);

  return (
    <div className="fc-toast-stack">
      {toasts.map((t) => (
        <Alert key={t.id} tone={t.type === 'error' ? 'danger' : t.type === 'success' ? 'success' : 'info'}>
          {t.message}
        </Alert>
      ))}
    </div>
  );
}
